
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/[handle]",
      function () {
        return require("private-next-pages/series/[handle].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/series/[handle]"])
      });
    }
  